import {
  FlexBox,
  Modal,
  ModalHeader,
  SessionBookingLinkType,
  SPACING,
} from "@joonapp/web-shared"

import { useSessionBookingModalStore } from "./hooks/useSessionBookingModalStore"
import useSessionModalStore from "./hooks/useSessionModalStore"
import useMobile from "../../../hooks/useMobile"
import { queryClient } from "../../../queryClient"
import { QueryKey } from "../../../types/queries"

const SessionBookingModal = () => {
  const { isOpen, onClose, link, linkType } = useSessionBookingModalStore()
  const { onClose: closeSessionModal } = useSessionModalStore()
  const isMobile = useMobile()

  const title = (() => {
    switch (linkType) {
      case SessionBookingLinkType.RESCHEDULE:
        return "Reschedule Session"
      case SessionBookingLinkType.CANCEL:
        return "Cancel Session"
      case SessionBookingLinkType.MAKEUP_BOOKING:
        return "Schedule Make-up Session"
      case SessionBookingLinkType.COACH_BOOKING:
      case SessionBookingLinkType.SCHEDULE:
        return "Schedule Session"
    }
  })()

  const handleClose = () => {
    queryClient.invalidateQueries([QueryKey.ALL_BILLING_PERIODS])
    queryClient.invalidateQueries([QueryKey.COACH_TODOS])
    onClose()
    closeSessionModal()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} animate mobileFull>
      <ModalHeader title={title} onClose={handleClose} />
      <FlexBox direction="column" gap={SPACING.space2}>
        <iframe
          src={link}
          frameBorder="0"
          title="Session Booking"
          style={{
            height: isMobile ? "100vh" : "min(700px, 100vh)",
            width: isMobile ? "100vw" : "min(100vw, 1000px)",
          }}
        ></iframe>
      </FlexBox>
    </Modal>
  )
}

export default SessionBookingModal
